import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Check from '@mui/icons-material/Check';
import StepConnector, { stepConnectorClasses } from '@mui/material/StepConnector';
import { Box, Divider, Paper } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import PromptInput from './CollectResponse/PromptInput';
import Completeoffer from './CollectResponse/Completeoffer';
import { GetLetterHeadAction } from '../../../../../store/Ancillary/LetterHead/Action';
import { GetCompanyLogoHelper } from '../../../Ancillary/CompanyDetails/helper/CompanyDetailsHelper';
import { getSignedUrl } from '@aws-sdk/s3-request-presigner';
import { s3Client } from '../../../Base/helper/baseFunctions';
import { GetObjectCommand } from '@aws-sdk/client-s3';
import CandidatePayroleTemplate from '../../../Finance/views/Employee/CandidatePayroleTemplate';

const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#8b44ff',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#8b44ff',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[600] : '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));

const QontoStepIconRoot = styled('div')(({ theme, ownerState }) => ({
    color: theme.palette.mode === 'dark' ? theme.palette.grey[500] : '#eaeaf0',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    ...(ownerState.active && {
        color: '#8b44ff',
    }),
    '& .QontoStepIcon-completedIcon': {
        color: '#8b44ff',
        zIndex: 1,
        fontSize: 18,
    },
    '& .QontoStepIcon-circle': {
        width: 8,
        height: 8,
        borderRadius: '50%',
        backgroundColor: 'currentColor',
    },
}));

function QontoStepIcon(props) {
    const { active, completed, className } = props;

    return (
        <QontoStepIconRoot ownerState={{ active }} className={className}>
            {completed ? (
                <Check className="QontoStepIcon-completedIcon" />
            ) : (
                <div className="QontoStepIcon-circle" />
            )}
        </QontoStepIconRoot>
    );
}

QontoStepIcon.propTypes = {
    /**
     * Whether this step is active.
     * @default false
     */
    active: PropTypes.bool,
    className: PropTypes.string,
    /**
     * Mark the step as completed. Is passed to child components.
     * @default false
     */
    completed: PropTypes.bool,
};


const defaultSteps = [
    'Candidate Info',
    'Offer CTC Config',
    'Complete Offer Letter',
];

const OfferLetterResponseStepper = (props) => {
    const { currentData, currentJobData, setIsOfferForm, setElements, OfferEdit, setCurrentData } = props

    const dispatch = useDispatch();
    const theme = useTheme();
    const [activeStep, setActiveStep] = useState(0);
    const [imageUrl, setImageUrl] = useState("");
    const { letterHeadData } = useSelector(state => state?.AncillaryReducer?.LetterHeadReducer);
    const [resData, setResData] = useState([]);
    const [isConfigureCtc, setIsConfigureCtc] = useState(
        currentData?.is_configure_ctc !== undefined ? Boolean(currentData?.is_configure_ctc) : true
    );
    const [payConfigResponse, setPayConfigResponse] = useState({
        payconfig_input_json : "",
        payconfig_content : ""
    })

    const steps = isConfigureCtc
        ? defaultSteps
        : ['Candidate Info', 'Complete Offer Letter'];

    useEffect(() => {
        dispatch(GetLetterHeadAction());
        GetCompanyLogoHelper().then((res) => {
            res?.data?.data?.[0]?.companylogo && getImageSignedUrl(res?.data?.data?.[0]?.companylogo);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const getImageSignedUrl = async (currentData) => {
        let filename = currentData;
        const bucketParams = {
            Bucket: process.env.REACT_APP_DO_BUCKET_NAME,
            Key: filename,
        };
        const expiresIn = 604800;
        try {
            const url = await getSignedUrl(
                s3Client,
                new GetObjectCommand(bucketParams),
                { expiresIn }
            ); // Adjustable expiration.
            setImageUrl(url); // This will update the imageUrl state
            return url;
        } catch (err) {
            console.error("Error fetching image URL", err);
        }
    };
    function getStepContent(stepIndex) {
        if (!isConfigureCtc) {
            switch (stepIndex) {
                case 0:
                    return (
                        <PromptInput
                            setActiveStep={setActiveStep}
                            activeStep={activeStep}
                            currentData={currentData}
                            currentJobData={currentJobData}
                            setResData={setResData}
                            resData={resData}
                            setIsOfferForm={setIsOfferForm}
                            OfferEdit={OfferEdit}
                            setElements={setElements}
                            setCurrentData={setCurrentData}
                            payConfigResponse={payConfigResponse}
                            setPayConfigResponse={setPayConfigResponse}
                            isConfigureCtc={isConfigureCtc}
                            setIsConfigureCtc={setIsConfigureCtc}
                        />
                    );
                case 1:
                    return (
                        <Completeoffer
                            setActiveStep={setActiveStep}
                            activeStep={activeStep}
                            currentData={currentData}
                            currentJobData={currentJobData}
                            setResData={setResData}
                            resData={resData}
                            setIsOfferForm={setIsOfferForm}
                            setElements={setElements}
                            OfferEdit={OfferEdit}
                            setCurrentData={setCurrentData}
                            companylogo={imageUrl}
                            letterHeadData={letterHeadData?.[0]}
                            payConfigResponse={payConfigResponse}
                            isConfigureCtc={isConfigureCtc}
                        />
                    );
                default:
                    return "Unknown stepIndex";
            }
        }

        switch (stepIndex) {
            case 0:
                return (
                    <PromptInput
                        setActiveStep={setActiveStep}
                        activeStep={activeStep}
                        currentData={currentData}
                        currentJobData={currentJobData}
                        setResData={setResData}
                        resData={resData}
                        setIsOfferForm={setIsOfferForm}
                        OfferEdit={OfferEdit}
                        setElements={setElements}
                        setCurrentData={setCurrentData}
                        payConfigResponse={payConfigResponse}
                        setPayConfigResponse={setPayConfigResponse}
                        isConfigureCtc={isConfigureCtc}
                        setIsConfigureCtc={setIsConfigureCtc}
                    />
                );
            case 1:
                return (
                    <Box maxWidth="md" sx={{ mx: "auto" }}>
                        <CandidatePayroleTemplate 
                            currentData={currentData} 
                            setActiveStep={setActiveStep} 
                            payConfigResponse={payConfigResponse}
                            setPayConfigResponse={setPayConfigResponse}
                        />
                    </Box>
                )
            case 2:
                return (
                    <Completeoffer
                        setActiveStep={setActiveStep} // not used
                        activeStep={activeStep}
                        currentData={currentData}
                        currentJobData={currentJobData}
                        setResData={setResData}
                        resData={resData}
                        setIsOfferForm={setIsOfferForm}
                        setElements={setElements}
                        OfferEdit={OfferEdit}
                        setCurrentData={setCurrentData}
                        companylogo={imageUrl}
                        letterHeadData={letterHeadData?.[0]}
                        payConfigResponse={payConfigResponse}
                        isConfigureCtc={isConfigureCtc}
                    />
                );
            default:
                return "Unknown stepIndex";
        }
    }

    return (
        <Paper sx={{ ".MuiDrawer-paper": { backgroundColor: `${theme.palette.mode === "dark" ? "#544166" : "white"}` }, borderRadius: "10px", paddingTop: "5px" }}>
            <Box sx={{ width: '100%' }}>
                <Stack sx={{ width: '100%' }} spacing={2}>
                    <Stepper alternativeLabel activeStep={activeStep} connector={<QontoConnector />}>
                        {steps.map((label) => (
                            <Step key={label}>
                                <StepLabel StepIconComponent={QontoStepIcon}>
                                    {label}
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Stack>
                <Divider variant="middle" flexItem sx={{ paddingTop: "5px", paddingBottom: "5px" }} />

                <div style={{ padding: "20px 0px 20px 0px", }}>
                    {getStepContent(activeStep)}
                </div>
            </Box>
        </Paper >

    );
}

export default OfferLetterResponseStepper;